import graphql__c91e3e597640d8460e76 from "./__generated__/CommentCard_comment.graphql.js";import { createFragmentContainer } from "react-relay";
import { graphql } from "react-relay";
import { useIntl, defineMessages } from "react-intl";
import classNames from "classnames";

import CommentButton from "./CommentButton";
import VoteButtons from "../Votable/VoteButtons";
import UserAvatar from "../Users/UserAvatar";
import UserAuthorName from "../Users/UserAuthorName";
import { Desktop, NonDesktop } from "../Utils/ResponsiveQueries";
import { withCommentForm } from "../GeneralServices/CommentFormService";
import parseDate from "../Utils/parseDate";
import RichText from "../Utils/RichText";
import Icon from "../Utils/Icon";
import Report from "../Reports/Report";
import { isUnauthorized } from "../Utils/authorizations";
import ReactableMeasures from "../ParticipativeModule/Visualizations/ReactableMeasures";

const CommentCard = ({ comment, showCommentForm, commentForm }) => {
  const { formatMessage, formatDate } = useIntl();

  const createdAt = formatDate(parseDate(comment.createdAt), {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric"
  });

  const commentClassName = classNames({
    "admin-highlight": comment.isFromAdminUser
  });

  const labels = {
    addComment: formatMessage(intlMessages.addComment),
    publicationDate: formatMessage(intlMessages.publicationDate, {
      date: createdAt
    }),
    contributionsClosed: formatMessage(intlMessages.commentsClosed),
    publiclyUnavailableMessage: formatMessage(intlMessages.publiclyUnavailableMessage)
  };

  const publiclyUnavailableMessage = comment.authorizations?.requiresModeration && (
    <div className="alert alert-warning border-radius with-icon">
      <Icon className="icon-error margin-right-sm text-greater" />
      <div className="with-icon-text">{labels.publiclyUnavailableMessage}</div>
    </div>
  );

  const footer = (() => {
    const {
      votesDisplayAuthorized,
      votesSubmissionAuthorized,
      commentsDisplayAuthorized,
      submitComment
    } = comment.authorizations || {};

    const displayVotesCounts =
      !isUnauthorized(votesDisplayAuthorized) &&
      isUnauthorized(votesSubmissionAuthorized);
    const displayCommentsCount =
      !isUnauthorized(commentsDisplayAuthorized) && isUnauthorized(submitComment);
    const displayCommentButton = !isUnauthorized(submitComment);
    const displayMeasures = displayVotesCounts || displayCommentsCount;

    if (!displayMeasures && !displayCommentButton) return null;

    return (
      <div className="d-flex card-footer border-radius-bottom padding-x-md padding-y-sm">
        {displayMeasures && (
          <ReactableMeasures
            reactable={comment}
            hideComments={displayCommentsCount}
            hideVotes={!displayVotesCounts}
            className="margin-right-sm"
          />
        )}

        {displayCommentButton && (
          <>
            <CommentButton
              count={comment.commentsCount}
              onClick={showCommentForm}
              disabledMessage={labels.contributionsClosed}
            />
            {commentForm}
          </>
        )}
      </div>
    );
  })();

  return (
    <div className="comment border-primary box-shadow position-relative">
      <div className={commentClassName}>
        <Desktop>
          <VoteButtons votable={comment} />
        </Desktop>

        <div className="padding-x-md padding-y-sm">
          <div className="comment-author d-flex align-items-center">
            <UserAvatar
              user={comment.author}
              className="contribution-author-avatar"
              size={35}
            />

            <div>
              <UserAuthorName user={comment.author} />
              <div className="text-title-overview-sm text-muted">
                {labels.publicationDate}
              </div>
            </div>
          </div>
        </div>

        {publiclyUnavailableMessage}

        <div className="padding-x-md padding-y-xs">
          <RichText className="comment-content" content={comment.content} />
        </div>

        <NonDesktop>
          <VoteButtons votable={comment} className="padding-x-md padding-y-xs" />
        </NonDesktop>

        <div className="d-flex justify-content-between padding-right-md">
          {footer}
          <Report reportable={comment} />
        </div>
      </div>
    </div>
  );
};

export default createFragmentContainer(withCommentForm(CommentCard), {
  comment: graphql__c91e3e597640d8460e76
});

const intlMessages = defineMessages({
  addComment: {
    id: "comments.comment.addComment",
    defaultMessage: "Commenter"
  },
  publicationDate: {
    id: "comments.comment.publicationDate",
    defaultMessage: "Publié le {date}"
  },
  publiclyUnavailableMessage: {
    id: "comments.comment.publiclyUnavailableMessage",
    defaultMessage: `
      Attention : Ce commentaire est en attente de modération et n'est pas
      encore publiquement visible, seul(e) vous pouvez la voir.
    `
  },
  commentsClosed: {
    id: "comments.list.commentsClosed",
    defaultMessage: "Les commentaires sont fermés"
  }
});
